/**
 * Desktop navigation: open a dropdown on hover, not only on click.
 */
export function initDesktopMenuHover() {
    if (window.innerWidth <= 992) return;

    document.querySelectorAll('.navbar .nav-item').forEach(function (everyitem) {
        everyitem.addEventListener('mouseover', function () {
            let el_link = this.querySelector('a[data-toggle]');

            if (el_link != null) {
                let nextEl = el_link.nextElementSibling;
                el_link.classList.add('show');
                if (nextEl) {
                    nextEl.classList.add('show');
                }
            }
        });
        everyitem.addEventListener('mouseleave', function () {
            let el_link = this.querySelector('a[data-toggle]');

            if (el_link != null) {
                let nextEl = el_link.nextElementSibling;
                el_link.classList.remove('show');
                if (nextEl) {
                    nextEl.classList.remove('show');
                }
            }
        });
    });
}
